import React from "react";
import EconomicTable from "../EconomicTable";
import { useMarketInternalsData } from "../../../context/MarketInternalsContext";

const LiquidityTab = () => {
    const { filteredRows: rows } = useMarketInternalsData();

    const data = rows.filter(row => row.Category === "LIQUIDITY");

    return <EconomicTable data={data} title="Liquidity Analysis" defaultRowData={{ Category: "LIQUIDITY", Topic: "Fed Balance Sheet" }} groupBy="Topic" groupOrder={["Fed Balance Sheet", "SOMA Holdings"]} useDataHook={useMarketInternalsData} />;
};

export default LiquidityTab;
